// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'align-left';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.563 2.248h15.75M.563 5.623h13.5M.563 8.998h16.875M.563 12.373h13.5m-13.5 3.375h15.75'
  />
);

export const viewBox = '0 0 18 18';
